import React, { lazy, memo, Suspense } from "react";
const GUID = await import("@asyncImports/GUID.js").then((mod) => mod.GUID);
const ShowResponsiveAds = lazy(
  () => import("@controls/ResponsiveAds/ShowResponsiveAds.js"),
);

const ResponsiveAds = ({ slot = null, format = "auto", adsIdx = 0 }) => {
  const guid = GUID();
  return (
    <Suspense fallback={<div className="loading responsiveAds" />}>
      <ShowResponsiveAds
        guid={guid}
        slot={slot}
        format={format}
        adsIdx={adsIdx}
      />
    </Suspense>
  );
};
export default memo(ResponsiveAds);
